import { render, staticRenderFns } from "./TabelaDeParcelas.vue?vue&type=template&id=02722efb&scoped=true"
import script from "./TabelaDeParcelas.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeParcelas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeParcelas.vue?vue&type=style&index=0&id=02722efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02722efb",
  null
  
)

export default component.exports